import React from "react";
import { useTranslation } from "react-i18next";
import InstructionPageShell from "./InstructionPageShell";

export default function InstructionServices() {
  const { t } = useTranslation("instructions");

  return (
    <InstructionPageShell
      blockTitle={t("services.blockTitle")}
      pageTitle={t("services.pageTitle")}
      body={t("services.body")}
    />
  );
}
